import { useEffect, useRef, useState } from "react";

// Hover-driven open/close with a short delay on close to allow for related mouse movements
// - for upload/search/similarity search icon button interactions
export const useHoverDelay = ({ closeDelayMs = 120 } = {}) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeTimerRef = useRef(null);

  const cancelPendingClose = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const open = () => {
    cancelPendingClose();
    setIsOpen(true);
  };

  const scheduleClose = () => {
    cancelPendingClose();
    closeTimerRef.current = setTimeout(() => {
      setIsOpen(false);
      closeTimerRef.current = null;
    }, closeDelayMs);
  };

  const close = () => {
    cancelPendingClose();
    setIsOpen(false);
  };

  useEffect(() => () => cancelPendingClose(), []);

  return { isOpen, open, scheduleClose, close };
};
